import ClockModel from '@/models/ClockModel'

const CONTENT_TYPE_MUSIC = ClockModel.CONTENT_TYPE_MUSIC
const CONTENT_TYPE_MARKETING = ClockModel.CONTENT_TYPE_MARKETING
const CONTENT_TYPE_PA = ClockModel.CONTENT_TYPE_PA

const emptyModel = {
  id: null,
  title: null,
  library_files: [],
  content_type: null,
  description: null,
  active_from: null,
  active_until: null
}

const emptyFilters = {
  title: undefined,
  client_id: undefined,
  is_active: undefined,
  attributes: {},
  include_expired: false
}

export default {
  CONTENT_TYPE_MUSIC,
  CONTENT_TYPE_MARKETING,
  CONTENT_TYPE_PA,
  emptyModel,
  emptyFilters
}
